module.exports = __webpack_public_path__ + "img/travel_agency.91c7eaf9.jpg";